import {
    MultiSelect,
    MultiSelectProps,
    styled,
} from '@volkswagen-onehub/components-core'
import React, {useEffect} from 'react'

const StyledResponsiveMultiSelect = styled(MultiSelect)`
    height: auto;
    min-height: 50px;
`

export default function ResponsiveMultiSelect(
    props: MultiSelectProps
): React.JSX.Element {
    // components-core falls back to static ids ("listbox", "multi-select-label"),
    // duplicated when more than one MultiSelect is on the page
    const labelId = props.labelId ?? `${props.name}-multi-select-label`
    const controlsId = props.controlsId ?? `${props.name}-listbox`

    // components-core doesn't expose props for the listbox and its options, so we
    // patch the DOM after every render (options and selection can change):
    // - the listbox gets an accessible name pointing to the visible label
    // - the checkboxes it renders get the option role, the only one (with group)
    //   allowed inside a listbox
    // - each checkbox also renders an aria-live region for its error message, never
    //   used by the MultiSelect: being exposed (aria-live), it is a child not allowed
    //   inside a listbox, so it becomes a plain span
    useEffect(() => {
        const listbox = document.getElementById(controlsId)

        if (!listbox) {
            return
        }

        if (props.label) {
            listbox.setAttribute('aria-labelledby', labelId)
        }

        listbox
            .querySelectorAll<HTMLInputElement>('input[type="checkbox"]')
            .forEach((checkbox) => {
                checkbox.setAttribute('role', 'option')
                checkbox.setAttribute('aria-selected', String(checkbox.checked))
            })

        listbox.querySelectorAll('[aria-live]').forEach((liveRegion) => {
            liveRegion.removeAttribute('aria-live')
            liveRegion.removeAttribute('aria-relevant')
        })
    })

    return (
        <StyledResponsiveMultiSelect
            {...props}
            labelId={labelId}
            controlsId={controlsId}
        />
    )
}
